import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const category = async (id: number) =>
  axios.get(Routes.COMPANY_PREFIX + '/' + id + '/' + Routes.CATEGORY);

export const useCategory = (id: number) =>
  useQuery({
    queryKey: [Keys.HOME_QRY, id],
    queryFn: () => category(id),
  });
